import React from 'react';
import { bool, node, string } from 'prop-types';
import classnames from 'classnames';

import './ribbon.scss';

const Ribbon = ({ children, className, isActive }) => (
    isActive ? (
        <div className={classnames(
            'ribbon',
            { [className]: classnames })}
        >{children}
        </div>
    ): null
);

Ribbon.defaultProps = {
    className: null,
    isActive: false
};

Ribbon.propTypes = {
    children: node.isRequired,
    className: string,
    isActive: bool
};

export default Ribbon;
